import { MatTableDataSourceExtended } from "@comunicare/comunicare-angular-interfaces";
import { QuestionnaireScoring } from "@comunicare/comunicare-interfaces";

export class ScoreDetailsDataSource extends MatTableDataSourceExtended<QuestionnaireScoring> {
  sortingDataAccessor = (data: QuestionnaireScoring, sortHeaderId: string): string | number => {
    switch (sortHeaderId) {
      case "name":
        return data.identifier.label.toLowerCase();
      case "value":
        return data.scoringValue;
      default:
        return "";
    }
  };

  constructor() {
    super();
  }

  public loadData(data: QuestionnaireScoring[]): void {
    this.data = data;
  }
}
